import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CountyData } from './iCountyData'

@Injectable()
export abstract class ICountyDataService{
    abstract getCounties(stateName:string):Observable<CountyData[]>;
}